import { z, tenantSlugSchema, uuidSchema } from '@kc3/validation';
export const isoDatetimeSchema = z.string().datetime();
export const baseEventFields = {
    tenantId: uuidSchema,
    tenantSlug: tenantSlugSchema,
    timestamp: isoDatetimeSchema,
};
//# sourceMappingURL=_base.js.map